/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_NameInputs */

const vi_product_classification_name = /** @type {(inputs: Product_Classification_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên phân loại`)
};

/**

* @param {Product_Classification_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_name = /** @type {((inputs?: Product_Classification_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_name(inputs)
});